import { render, staticRenderFns } from "./ManualList.vue?vue&type=template&id=5c5e637f&scoped=true&"
import script from "./ManualList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ManualList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ManualList.vue?vue&type=style&index=0&id=5c5e637f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e637f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5e637f')) {
      api.createRecord('5c5e637f', component.options)
    } else {
      api.reload('5c5e637f', component.options)
    }
    module.hot.accept("./ManualList.vue?vue&type=template&id=5c5e637f&scoped=true&", function () {
      api.rerender('5c5e637f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/ManualList.vue"
export default component.exports